<template lang="pug">
  .d-flex.align-center.justify-center.coming-soon
    .text-sm.neutral500--text Coming soon
</template>

<script>
export default {
}
</script>

<style scoped>
.coming-soon {
  height: 100dvh;
}
</style>